module.exports = __webpack_public_path__ + "static/canvas-cd89844e286fe371fcf5247f5fdcd959.jpg";